import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
export function MobileStickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 560);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-181" data-mp="mgdl51dqwxs2">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 mx-auto w-full max-w-[480px] border-t border-espresso-line bg-espresso/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-182" data-mp="mfarilp1gh8g">
          <CtaButton className="py-3.5" data-id="element-183" data-mp="1586gh2gaev2y">Voglio il pack — {offer.price}</CtaButton>
        </motion.div>}
    </AnimatePresence>;
}